// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__3EBei","tooltip":"Tooltip_tooltip__khvVR","tooltiptext":"Tooltip_tooltiptext__1oz7k"};